// extracted by mini-css-extract-plugin
export default {"melodyVideo":"OJ-z","isFullWidth":"PJ-z","landingPageVideo":"QJ-z","play":"RJ-z","iframeVideo":"SJ-z","playHidden":"TJ-z","fullwidth":"UJ-z"};